<template>
    <div class="news">
     <div class="title wow fadeInUp">
         <p>news</p>
         <p>新闻中心</p>
     </div>
        <div class="content">
       <div class="hNews wow fadeInLeft" @click="gotoInfo(nInfo.id)">
          <p>{{nInfo.title}}</p>
           <p>
               {{nInfo.description}}</p>
           <p>{{nInfo.posttime | formatDate}}</p>
           <div>
               <img :src="`http://www.yanbao-cheguanjia.com/${nInfo.picurl}`" alt="">
           </div>
       </div>
            <div class="nList wow fadeInRight">
              <div class="item" v-for="(item,index) in list" :key="index" @click="gotoInfo(item.id)">
              <div class="left">
                  <img :src="`http://www.yanbao-cheguanjia.com/${item.picurl}`" alt="">
              </div>
                  <div class="right">
                   <p>{{item.title}}</p>
                      <p>{{item.description}}</p>
                      <p>{{item.posttime | formatDate}}</p>
                  </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getProductsUrl,getHome} from '../util/lang'
    export default {
        name: "news",
        data(){
            return{
                nInfo:'',
                list:[]
            }
        },
        filters: {
            formatDate: function (value) {
                value=parseInt(value)*1000
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? ('0' + MM) : MM;
                let d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                let h = date.getHours();
                h = h < 10 ? ('0' + h) : h;
                let m = date.getMinutes();
                m = m < 10 ? ('0' + m) : m;
                let s = date.getSeconds();
                s = s < 10 ? ('0' + s) : s;
                return y + '-' + MM + '-' + d + ' ' ;
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.getNews('9')
                this.getPro2()
            })
        },
        methods:{
            getPro2(){
                this.$nextTick(()=>{
                    const url = `${getHome('RecommendProduct2')}`
                    this.$axios.get(url).then(res => {
                        this.list=res.data
                        console.log(this.list)
                    })
                })
            },
            getNews(id){
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    res.data.data.map((item)=>{
                        if(item.flag=='h'){
                            this.nInfo=item
                        }
                    })
                })
            },
            gotoInfo(id){
                const link=`/newsInfo.html?id=${id}`
                window.open(link,'_blank')
            }
        }
    }
</script>

<style lang="scss" scoped>
.news{
    width:1440px;
    margin: 60px auto;
    animation-duration: 3s;
    .title{
        width:100%;
        p:nth-child(1){
            color:#286AA0;
           font-family: "DINEngschriftStd";
            font-size: 40px;
            text-transform: uppercase;
        }
        p:nth-child(2){
            font-family: "SourceHanSansSC-Normal.otf";
        }
    }
    .content{
        width:100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 30px auto;
        .hNews{
            width:30%;
            background-color: #F6F6F6;
         padding-bottom: 10px;
            p{
                width:90%;
                margin-left: 5%;
            }
            p:nth-child(1){
                color:#000500;
                font-family: "SourceHanSansSC-Normal.otf";
                font-size: 18px;
                margin: 30px auto;
            }
            p:nth-child(2){
                font-size: 14px;
                font-family: "SOURCEHANSANSCN-LIGHT";
                line-height: 25px;
            }
            p:nth-child(3){
                text-align: right;
                font-family: "it";
                font-size: 14px;
            }
            div{
                width:90%;
                margin:20px auto;
                cursor: pointer;
                overflow: hidden;
                img{
                    width:100%;
                    object-fit: cover;
                    display: block;
                    transition: all 600ms;
                }
                &:hover{
                    img{
                        transform: scale(1.05);
                    }
                }
            }
        }
        .nList{
            width:65%;
            display: flex;
            flex-direction: column;
            .item{
                width:100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                border-bottom: 1px solid #ECECEC;
                padding: 10px 0;
                cursor: pointer;
                align-items: center;
                .left{
                    width:20%;
                    overflow: hidden;
                    img{
                        width:100%;
                        object-fit: cover;
                        display: block;
                        transition: all 600ms;
                    }
                }
                .right{
                    width:78%;
                    p:nth-child(1){
                        font-family: "SourceHanSansSC-Normal.otf";
                        font-size: 18px;
                        color:#000500;
                        margin-top: 15px;
                        transition: all 600ms;
                    }
                    p:nth-child(2){
                        font-family: "SOURCEHANSANSCN-LIGHT";
                        font-size: 14px;
                        color:#000500;
                        margin: 20px auto;
                        line-height: 30px;
                        display: -webkit-box;
                        height:60px;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        transition: all 600ms;
                    }
                    p:nth-child(3){
                        font-family: "it";
                        font-size: 14px;
                        text-align: right;
                        transition: all 600ms;
                    }
                }
                &:hover{
                    .left{
                        img{
                            transform: scale(1.05);
                        }
                    }
                    .right{
                        p:nth-child(1),p:nth-child(3){
                            color:#286AA0;
                        }
                        p:nth-child(2){
                            color:#F47238;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1440px){
        width:90%;
    }
    @media screen and (max-width: 1000px){
    .content{
        flex-direction: column;
        .hNews,.nList{
            width:100%;
            animation: none;
        }
        .nList{
             .item{
                 flex-direction: column;
                 .left,.right{
                     width:100%;
                 }
             }
        }
    }
    }
}
</style>
